import occupationInfo from "./occupationInfo.js"
export default {
    state: {
        language: "en_US",
        fontSize:0,
        selectMenu:0,
        innerWidth:0,
        scrollT:0,
        formatDate:function(){},
        monthArray:['January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                    ],
        // knowMore:knowMore,
        occupationInfo:occupationInfo,
        swiperOption: {
            slidesPerView: 2.2,
            spaceBetween: 0,
        },
        coursesType:0,
        pathType:0,
        walkOption:0,
        formData:{},
        zi:'All',
        isPreview:false,
        occupationsFilter:{},
        mate:{
            keywords:"hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
            title:"talent.gov.hk - One-stop Manpower Information Portal",
            description:"Explore over 20000 job vacancies from the government and major job boards, over 300 career profiles and more than 10000 courses to find your ideal career and learning pathways! About us: talent.gov.hk is an information portal established by the Human Resources Planning Commission of the HKSAR Government, providing consolidated manpower information to facilitate the making of informed choices in respect of career, learning and development pathways.",
            image:"https://saprdwebsto01.blob.core.windows.net/assets/image/logo_.png",
            width:1000,
            height:800,
            url:"https://www.talent.gov.hk/",
            imageType:"image/png"
        }
    },
    mutations: {

        setLanguage(state, language) {
            state.language = language;
        },
        formatDate:function(){}
    },
    getters: {
        getContent: (state) => (object) => {
            
        	return !object||object.length==0?"":object.find(o=>o.langCode==state.language).content;
        },
        getEnContent: (state) => (object) => {
            
        	return !object||object.length==0?"":object.find(o=>o.langCode=='en_US').content;
        },
        getObject: (state) => (object) => {
            
            return !object||object.length==0?{}:object.find(o=>o.langCode==state.language);
        },
        replaceEvent: (state) => (val) => {
            var reg = new RegExp("[ +`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"); 
            var rs = ""; 
            for (var i = 0, l = val.length; i < val.length; i++) { 
                rs = rs + val.substr(i, 1).replace(reg, ' '); 
            }
            var val = rs;
            var rs = "";
            for (var i = 0, l = val.length; i < val.length; i++) { 
                rs = rs + val.substr(i, 1).replace(' ', '-'); 
            }
            for(var i=0;i<100;i++){
                var rs = rs.replace("--", '-');
            }
            if(rs.substring(rs.length-1,rs.length)=='-'){
                rs = rs.substring(0,rs.length-1);
            }
            if(rs.substring(0,1)=='-'){
                rs = rs.substring(1,rs.length);
            }
            return rs;
        },
        // getKnowMore: (state) => (id) => {
        //     return state.knowMore.data.filter(knowMore=>knowMore.langCode==state.language&&knowMore.id==id);
        // },
        getVTClink: (state) => (id) => {
            return state.occupationInfo.VTCLink.filter(link=>link.langCode==state.language&&link.id==id);
        },
        getInformation: (state) => (key) => {
            return state.occupationInfo[key].filter(occupationInfo=>occupationInfo.langCode==state.language);
        },
        getTrim:(state) =>(str)=>{
            return str.trim()
        }
    }
}